import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Capture the PWA install prompt globally (it fires on load, before Profilo mounts)
if (typeof window !== "undefined") {
  window.__bwInstallPrompt = window.__bwInstallPrompt || null;
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__bwInstallPrompt = e;
    window.dispatchEvent(new Event("bw-installprompt"));
  });
  window.addEventListener("appinstalled", () => {
    window.__bwInstallPrompt = null;
  });
}

// Register the PWA service worker (enables "Add to Home Screen" + offline resilience)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
